@if (showHeader()) {
  <div class="hx-call-participants__header">
    <span class="hx-call-participants__title">
      <hx-icon svgIcon="cc-people" aria-hidden="true" />
      Participants
    </span>
    <span class="hx-call-participants__count" aria-label="{{ totalCount() }} participants">
      {{ totalCount() }}
    </span>
  </div>
}

<!-- Waiting room section -->
@if (showWaitingRoom() && waitingParticipants().length > 0) {
  <div class="hx-call-participants__section">
    <h3 class="hx-call-participants__section-title">Waiting ({{ waitingParticipants().length }})</h3>
    <ul class="hx-call-participants__list" role="list" aria-label="Waiting room">
      @for (p of waitingParticipants(); track p.id) {
        <li class="hx-call-participants__item hx-call-participants__item--waiting" role="listitem">
          <div class="hx-call-participants__avatar" aria-hidden="true">
            <hx-avatar [src]="p.avatarSrc" [initials]="p.initials" [name]="p.name" size="sm" />
          </div>
          <div class="hx-call-participants__info">
            <span class="hx-call-participants__name">{{ p.name }}</span>
            @if (p.role) {
              <span class="hx-call-participants__role">{{ p.role }}</span>
            }
          </div>
          <button
            hxButton
            variant="outline"
            context="positive"
            size="xs"
            type="button"
            [attr.aria-label]="'Admit ' + p.name"
            (click)="admitParticipant.emit(p)">
            Admit
          </button>
        </li>
      }
    </ul>
  </div>
}

<!-- Active participants section -->
<div class="hx-call-participants__section">
  @if (showWaitingRoom() && waitingParticipants().length > 0) {
    <h3 class="hx-call-participants__section-title">In call ({{ activeParticipants().length }})</h3>
  }

  @if (activeParticipants().length === 0) {
    <p class="hx-call-participants__empty">No participants yet.</p>
  } @else {
    <ul class="hx-call-participants__list" role="list" aria-label="Call participants">
      @for (p of activeParticipants(); track p.id) {
        <li
          class="hx-call-participants__item"
          [class.hx-call-participants__item--speaking]="p.isSpeaking"
          role="listitem"
          (click)="participantClick.emit(p)">
          <!-- Avatar -->
          <div class="hx-call-participants__avatar" aria-hidden="true">
            <hx-avatar
              [src]="p.avatarSrc"
              [initials]="p.initials"
              [name]="p.name"
              [size]="layout() === 'grid' ? 'md' : 'sm'" />
            @if (p.isSpeaking) {
              <span class="hx-call-participants__speaking-dot" aria-hidden="true"></span>
            }
          </div>

          <!-- Name + role -->
          <div class="hx-call-participants__info">
            <span class="hx-call-participants__name">
              {{ p.name }}
              @if (p.isLocal) {
                <span class="hx-call-participants__you">(You)</span>
              }
              @if (p.isHost) {
                <span class="hx-call-participants__host-badge">Host</span>
              }
            </span>
            @if (p.role) {
              <span class="hx-call-participants__role">{{ p.role }}</span>
            }
          </div>

          <!-- Status icons -->
          <div class="hx-call-participants__status" aria-hidden="true">
            @if (showConnectionQuality()) {
              <hx-connection-quality [quality]="getQuality(p)" size="xs" />
            }
            @if (p.isMuted) {
              <span
                class="hx-call-participants__icon hx-call-participants__icon--muted"
                aria-label="{{ p.name }} is muted">
                <hx-icon svgIcon="cc-microphone-slash" aria-hidden="true" />
              </span>
            }
            @if (p.isVideoOff) {
              <span
                class="hx-call-participants__icon hx-call-participants__icon--video-off"
                aria-label="{{ p.name }} camera is off">
                <hx-icon svgIcon="cc-video-slash" aria-hidden="true" />
              </span>
            }
          </div>
        </li>
      }
    </ul>
  }
</div>
